<template>
    <div class="fillcontain">
      <panelGroup></panelGroup>
      <statOrderChart></statOrderChart>
      <statGoods></statGoods>

    </div>
</template>

<script>
    import panelGroup from './components/PanelGroup'
    import statOrderChart from './components/StatOrdersChart'
    import statGoods from './components/StatGoods'
    export default {
        components: {
            panelGroup,
            statOrderChart,
            statGoods
        },
        data(){
            return {

            }
        },
        created(){
        },
        methods: {
        },
    }
</script>

<style lang="less">
	  @import '../../style/mixin';
   .dashboard-editor-container {
     padding: 32px;
     background-color: rgb(240, 242, 245);
     .chart-wrapper {
       background: #fff;
       padding: 16px 16px 0;
       margin-bottom: 32px;
     }
   }
</style>
<style  lang="less">
  .text {
    font-size: 14px;
  }
  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/Home.vue